import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";

import { useAuth } from "@/lib/auth";
import { ROLE_LABELS } from "@/lib/constants";
import { SECTIONS } from "@/components/layouts/admin-layout";
import { useAdminMe } from "@/components/admin-ui";
import { ErrorState, Loading, Pill } from "@/components/ui";

export default function AdminHome() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { data, isLoading, isError, error, refetch } = useAdminMe();
  if (isLoading) return <Loading />;
  if (isError) return <ErrorState testId="admin-home-error" message={error.message} onRetry={() => refetch()} />;
  const visible = SECTIONS.filter((s) => data.permissions.includes(s.perm));
  return (
    <div data-testid="admin-home-screen">
      <p className="text-xs font-bold uppercase tracking-[1.6px] text-[#D48D93]">LOVE NET</p>
      <h1 className="text-[42px] leading-tight">Admin</h1>
      <p className="text-sm text-muted-foreground" data-testid="admin-name">{data.name ?? user?.full_name}</p>
      <div className="mb-6 mt-3 flex flex-wrap gap-1.5" data-testid="admin-roles">
        {data.roles.map((r) => <Pill key={r} label={ROLE_LABELS[r] ?? r} tone="rose" testId={`admin-role-${r}`} />)}
      </div>
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {visible.map((s, i) => (
          <button key={s.key} data-testid={`admin-tile-${s.key}`} onClick={() => navigate(s.href)} style={{ animationDelay: `${i * 40}ms` }}
            className="fade-up flex items-center gap-4 rounded-[20px] border border-border bg-white p-5 text-left transition-all hover:-translate-y-0.5 hover:border-[#D48D93] hover:shadow-md">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#F6E3E4]"><s.Icon className="h-[22px] w-[22px] text-primary" /></span>
            <span className="flex-1"><span className="block font-display text-[22px]">{s.title}</span><span className="block text-xs text-muted-foreground">{s.desc}</span></span>
            <ChevronRight className="h-[18px] w-[18px] text-muted-foreground" />
          </button>
        ))}
      </div>
    </div>
  );
}
